import React, { useState, useRef, useEffect } from 'react';
import styles from './Hedefler.css';
import PageHeader from '../../components/PageHeader/PageHeader';
import Table from '../../components/Table/Table';
import { Tabs, Tab } from '../../components/Tabs/Tabs';
import FilterCard from '../../components/FilterCard/FilterCard';
import { FaFileExcel } from 'react-icons/fa';
import { BsSearch, BsChevronDown, BsInboxFill } from 'react-icons/bs';
import Select from '../../components/Select/Select';

const NoDataFound = () => (
  <div className="no-data-found">
    <BsInboxFill className="no-data-icon" />
    <h3 className="no-data-title">Gösterilecek Veri Bulunamadı</h3>
    <p className="no-data-text">
      Arama kriterlerinize uygun veri bulunmamaktadır. Lütfen filtrelerinizi değiştirerek tekrar deneyin.
    </p>
  </div>
);

const CustomSelect = ({ options, value, onChange, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredOptions = options.filter(option =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleOptionClick = (option) => {
    const newValue = value.some(v => v.value === option.value)
      ? value.filter(v => v.value !== option.value)
      : [...value, option];
    
    if (option.value === 'all') {
      onChange([option]);
    } else {
      const withoutAll = newValue.filter(v => v.value !== 'all');
      onChange(withoutAll);
    }
  };

  return (
    <div className={styles.customSelect} ref={dropdownRef}>
      <div 
        className={styles.selectControl} 
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className={styles.selectedValues}>
          {value.length > 0 
            ? value.map(v => v.label).join(', ') 
            : placeholder}
        </div>
        <BsChevronDown className={`${styles.arrow} ${isOpen ? styles.open : ''}`} />
      </div>
      
      {isOpen && (
        <div className={styles.dropdown}>
          <div className={styles.searchBox}>
            <BsSearch className={styles.searchIcon} />
            <input
              type="text"
              placeholder="Ara..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          <div className={styles.optionsList}>
            {filteredOptions.map(option => (
              <div
                key={option.value}
                className={styles.option}
                onClick={() => handleOptionClick(option)}
              >
                <input
                  type="checkbox"
                  checked={value.some(v => v.value === option.value)}
                  onChange={() => {}}
                  className={styles.checkbox}
                />
                <span>{option.label}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const Hedefler = () => {
  const [activeTab, setActiveTab] = useState('birim-makale');
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [selectedFaculties, setSelectedFaculties] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([{ value: 'devam-ediyor', label: 'Devam Ediyor' }]);
  const [selectedYear, setSelectedYear] = useState([{ value: '2025', label: '2025' }]);

  const yearOptions = [
    { value: 'all', label: 'Tüm Yıllar' },
    { value: '2024', label: '2024' },
    { value: '2025', label: '2025' },
    { value: '2026', label: '2026' }
  ];

  const statusOptions = [
    { value: 'tamamlandi', label: 'Tamamlandı' },
    { value: 'tamamlanamadi', label: 'Tamamlanamadı' },
    { value: 'devam-ediyor', label: 'Devam Ediyor' }
  ];

  const facultyOptions = [
    { value: 'all', label: 'Tüm Fakülteler' },
    { value: 'muhendislik', label: 'Mühendislik Fakültesi' },
    { value: 'mimarlik', label: 'Mimarlık Fakültesi' },
    { value: 'fen', label: 'Fen Fakültesi' }
  ];

  const departmentOptions = [
    { value: 'all', label: 'Tüm Bölümler' },
    { value: 'endustri', label: 'Endüstri Mühendisliği' },
    { value: 'bilgisayar', label: 'Bilgisayar Mühendisliği' },
    { value: 'makine', label: 'Makine Mühendisliği' },
    { value: 'mimarlik', label: 'Mimarlık' },
    { value: 'sehir', label: 'Şehir ve Bölge Planlama' },
    { value: 'fizik', label: 'Fizik Mühendisliği' }
  ];

  const handleFacultyChange = (selectedOptions) => {
    setSelectedFaculties(selectedOptions);
    if (selectedOptions.some(option => option.value === 'all')) {
      setSelectedFaculties([{ value: 'all', label: 'Tüm Fakülteler' }]);
    }
  };

  const handleDepartmentChange = (selectedOptions) => {
    setSelectedDepartments(selectedOptions);
    if (selectedOptions.some(option => option.value === 'all')) {
      setSelectedDepartments([{ value: 'all', label: 'Tüm Bölümler' }]);
    }
  };

  const handleStatusChange = (selectedOptions) => {
    setSelectedStatus(selectedOptions);
    if (selectedOptions.some(option => option.value === 'devam-ediyor')) {
      setSelectedStatus([{ value: 'devam-ediyor', label: 'Devam Ediyor' }]);
    }
  };

  const handleYearChange = (selectedOptions) => {
    setSelectedYear(selectedOptions);
    if (selectedOptions.some(option => option.value === 'all')) {
      setSelectedYear([{ value: 'all', label: 'Tüm Yıllar' }]);
    }
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const handleExcelExport = () => {
  };

  const getFilteredAndSortedData = (data) => {
    let filteredData = data.filter(item => {
      const matchesSearch = Object.values(item).some(val => 
        val.toString().toLowerCase().includes(searchTerm.toLowerCase())
      );

      const matchesFaculty = selectedFaculties.length === 0 || 
        selectedFaculties.some(f => f.value === 'all') ||
        selectedFaculties.some(f => f.value === item.fakulte?.toLowerCase().replace(/\s+/g, ''));

      const matchesDepartment = selectedDepartments.length === 0 ||
        selectedDepartments.some(d => d.value === 'all') ||
        selectedDepartments.some(d => d.value === item.bolum?.toLowerCase().replace(/\s+/g, ''));

      const matchesStatus = selectedStatus.length === 0 || 
                          (selectedStatus[0].value === 'tamamlandi' ? item.tamamlandi :
                           selectedStatus[0].value === 'tamamlanamadi' ? !item.tamamlandi && item.sonTarihGecti :
                           selectedStatus[0].value === 'devam-ediyor' ? !item.tamamlandi && !item.sonTarihGecti :
                           true);

      const matchesYear = selectedYear.length === 0 ||
                         selectedYear.some(y => y.value === 'all') ||
                         selectedYear.some(y => y.value === item.yil?.toString());

      return matchesSearch && matchesFaculty && matchesDepartment && matchesStatus && matchesYear;
    });

    if (sortConfig.key) {
      filteredData.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    return filteredData;
  };

  const columns = {
    'birim-makale': [
      { key: 'unvan', title: 'Ünvan', sortable: true },
      { key: 'adSoyad', title: 'Ad-Soyad', sortable: true },
      { key: 'fakulte', title: 'Fakülte', sortable: true },
      { key: 'bolum', title: 'Bölüm', sortable: true },
      { key: 'yil', title: 'Yıl', sortable: true },
      { key: 'hedef', title: 'Hedef', sortable: true },
      { key: 'notlar', title: 'Notlar' },
    ],
    'birim-proje': [
      { key: 'unvan', title: 'Ünvan', sortable: true },
      { key: 'adSoyad', title: 'Ad-Soyad', sortable: true },
      { key: 'fakulte', title: 'Fakülte', sortable: true },
      { key: 'bolum', title: 'Bölüm', sortable: true },
      { key: 'yil', title: 'Yıl', sortable: true },
      { key: 'hedef', title: 'Hedef', sortable: true },
      { key: 'notlar', title: 'Notlar' },
    ],
    'akademisyen-makale': [
      { key: 'unvan', title: 'Ünvan', sortable: true },
      { key: 'adSoyad', title: 'Ad-Soyad', sortable: true },
      { key: 'fakulte', title: 'Fakülte', sortable: true },
      { key: 'bolum', title: 'Bölüm', sortable: true },
      { key: 'yil', title: 'Yıl', sortable: true },
      { key: 'hedef', title: 'Hedef', sortable: true },
      { key: 'notlar', title: 'Notlar' },
    ],
    'akademisyen-proje': [
      { key: 'unvan', title: 'Ünvan', sortable: true },
      { key: 'adSoyad', title: 'Ad-Soyad', sortable: true },
      { key: 'fakulte', title: 'Fakülte', sortable: true },
      { key: 'bolum', title: 'Bölüm', sortable: true },
      { key: 'yil', title: 'Yıl', sortable: true },
      { key: 'hedef', title: 'Hedef', sortable: true },
      { key: 'notlar', title: 'Notlar' },
    ]
  };

  const mockData = {
    'birim-makale': [
      {
        id: 1,
        unvan: 'Dr. Öğr. Üyesi',
        adSoyad: 'Zeynep Değer',
        fakulte: 'Afet Yönetimi Enstitüsü',
        bolum: 'Afet Yönetimi Enstitüsü',
        yil: '2025',
        hedef: 2,
        notlar: '1 adet TÜBİTAK, 1 adet BAP projesi hedeflenmektedir.',
        tamamlandi: false,
        sonTarihGecti: false
      },
      {
        id: 2,
        unvan: 'Doç. Dr.',
        adSoyad: 'Didem Saloğlu Dertli',
        fakulte: 'Afet Yönetimi Enstitüsü',
        bolum: 'Afet Yönetimi Enstitüsü',
        yil: '2025',
        hedef: 0,
        notlar: 'Proje hedefi hedeflenmemektedir.',
        tamamlandi: true,
        sonTarihGecti: false
      },
      {
        id: 3,
        unvan: 'Doç. Dr.',
        adSoyad: 'Ufuk Yazgan',
        fakulte: 'Afet Yönetimi Enstitüsü',
        bolum: 'Afet Yönetimi Enstitüsü',
        yil: '2025',
        hedef: 0,
        notlar: '2 adet döner sermaye projesi hedeflenmektedir.',
        tamamlandi: false,
        sonTarihGecti: true
      }
    ],
    'birim-proje': [
      {
        id: 1,
        unvan: 'Dr. Öğr. Üyesi',
        adSoyad: 'Ömer Ekmekçioğlu',
        fakulte: 'Afet Yönetimi Enstitüsü',
        bolum: 'Afet Yönetimi Enstitüsü',
        yil: '2025',
        hedef: 2,
        notlar: '1 adet BAP, 1 adet TTO projesi hedeflenmektedir.',
        tamamlandi: false,
        sonTarihGecti: false
      },
      {
        id: 2,
        unvan: 'Doç. Dr.',
        adSoyad: 'Çağlar Akkaya',
        fakulte: 'Afet Yönetimi Enstitüsü',
        bolum: 'Afet Yönetimi Enstitüsü',
        yil: '2025',
        hedef: 1,
        notlar: '1 adet BAP projesi hedeflenmektedir.',
        tamamlandi: false,
        sonTarihGecti: false
      }
    ],
    'akademisyen-makale': [
      {
        id: 1,
        unvan: 'Dr. Öğr. Üyesi',
        adSoyad: 'Zeynep Değer',
        fakulte: 'Afet Yönetimi Enstitüsü',
        bolum: 'Afet Yönetimi Enstitüsü',
        yil: '2025',
        hedef: 2,
        notlar: '1 adet TÜBİTAK, 1 adet BAP projesi hedeflenmektedir.',
        tamamlandi: false,
        sonTarihGecti: false
      },
      {
        id: 2,
        unvan: 'Doç. Dr.',
        adSoyad: 'Didem Saloğlu Dertli',
        fakulte: 'Afet Yönetimi Enstitüsü',
        bolum: 'Afet Yönetimi Enstitüsü',
        yil: '2025',
        hedef: 0,
        notlar: 'Proje hedefi hedeflenmemektedir.',
        tamamlandi: true,
        sonTarihGecti: false
      },
      {
        id: 3,
        unvan: 'Doç. Dr.',
        adSoyad: 'Ufuk Yazgan',
        fakulte: 'Afet Yönetimi Enstitüsü',
        bolum: 'Afet Yönetimi Enstitüsü',
        yil: '2025',
        hedef: 0,
        notlar: '2 adet döner sermaye projesi hedeflenmektedir.',
        tamamlandi: false,
        sonTarihGecti: true
      },
      {
        id: 4,
        unvan: 'Dr. Öğr. Üyesi',
        adSoyad: 'Ömer Ekmekçioğlu',
        fakulte: 'Afet Yönetimi Enstitüsü',
        bolum: 'Afet Yönetimi Enstitüsü',
        yil: '2025',
        hedef: 2,
        notlar: '1 adet BAP, 1 adet TTO projesi hedeflenmektedir.',
        tamamlandi: false,
        sonTarihGecti: false
      },
      {
        id: 5,
        unvan: 'Doç. Dr.',
        adSoyad: 'Çağlar Akkaya',
        fakulte: 'Afet Yönetimi Enstitüsü',
        bolum: 'Afet Yönetimi Enstitüsü',
        yil: '2025',
        hedef: 1,
        notlar: '1 adet BAP projesi hedeflenmektedir.',
        tamamlandi: false,
        sonTarihGecti: false
      }
    ],
    'akademisyen-proje': [
      {
        id: 1,
        unvan: 'Dr. Öğr. Üyesi',
        adSoyad: 'Zeynep Değer',
        fakulte: 'Afet Yönetimi Enstitüsü',
        bolum: 'Afet Yönetimi Enstitüsü',
        yil: '2025',
        hedef: 2,
        notlar: '1 adet TÜBİTAK, 1 adet BAP projesi devam etmekte.',
        tamamlandi: false,
        sonTarihGecti: false
      },
      {
        id: 2,
        unvan: 'Doç. Dr.',
        adSoyad: 'Didem Saloğlu Dertli',
        fakulte: 'Afet Yönetimi Enstitüsü',
        bolum: 'Afet Yönetimi Enstitüsü',
        yil: '2025',
        hedef: 0,
        notlar: 'Aktif proje bulunmamaktadır.',
        tamamlandi: true,
        sonTarihGecti: false
      },
      {
        id: 3,
        unvan: 'Doç. Dr.',
        adSoyad: 'Ufuk Yazgan',
        fakulte: 'Afet Yönetimi Enstitüsü',
        bolum: 'Afet Yönetimi Enstitüsü',
        yil: '2025',
        hedef: 0,
        notlar: '2 adet döner sermaye projesi yürütülmekte.',
        tamamlandi: false,
        sonTarihGecti: true
      },
      {
        id: 4,
        unvan: 'Dr. Öğr. Üyesi',
        adSoyad: 'Ömer Ekmekçioğlu',
        fakulte: 'Afet Yönetimi Enstitüsü',
        bolum: 'Afet Yönetimi Enstitüsü',
        yil: '2025',
        hedef: 2,
        notlar: '1 adet BAP, 1 adet TTO projesi devam etmekte.',
        tamamlandi: false,
        sonTarihGecti: false
      },
      {
        id: 5,
        unvan: 'Doç. Dr.',
        adSoyad: 'Çağlar Akkaya',
        fakulte: 'Afet Yönetimi Enstitüsü',
        bolum: 'Afet Yönetimi Enstitüsü',
        yil: '2025',
        hedef: 1,
        notlar: '1 adet BAP projesi değerlendirme aşamasında.',
        tamamlandi: false,
        sonTarihGecti: false
      }
    ]
  };

  return (
    <div className="wrapper">
      <PageHeader 
        title="Hedefler"
        description="Akademik personelin yıllık makale ve proje hedeflerinin takibi ve gerçekleşme durumlarının izlenmesi"
        breadcrumbs={[
          { text: 'Ana Sayfa', href: '/' },
          { text: 'Hedefler'},
        ]}
        className=""
      />

      <FilterCard title="" className={`${styles['filter-card']}`}>
        <FilterCard.Row className={`${styles['filter-row']} text-end`}>
          <FilterCard.Col className={styles['filter-col']}>
            <FilterCard.Button 
              className={`${styles.button} ${styles['button-success']}`}
              variant="success"
              icon={<FaFileExcel />}
              onClick={handleExcelExport}
            >
              Excel'e Aktar
            </FilterCard.Button>
          </FilterCard.Col>
        </FilterCard.Row>
        
        <FilterCard.Row className={styles['filter-row']}>
          <FilterCard.Col className={styles['filter-col']}>
            <FilterCard.FormGroup label="Fakülte" className={`${styles['form-group']}`}>
              <Select
                options={facultyOptions}
                value={selectedFaculties}
                onChange={handleFacultyChange}
                placeholder="Fakülte seçin..."
                className="dark:bg-gray-700 dark:text-white"
                classNamePrefix="dark-select"
              />
            </FilterCard.FormGroup>
          </FilterCard.Col>
          <FilterCard.Col className={styles['filter-col']}>
            <FilterCard.FormGroup label="Bölüm" className={`${styles['form-group']} text-dark dark:text-white`}>
              <Select
                options={departmentOptions}
                value={selectedDepartments}
                onChange={handleDepartmentChange}
                placeholder="Bölüm seçin..."
                className="dark:bg-gray-700 dark:text-white"
                classNamePrefix="dark-select"
              />
            </FilterCard.FormGroup>
          </FilterCard.Col>
          <FilterCard.Col className={styles['filter-col']}>
            <FilterCard.FormGroup label="Yıl" className={`${styles['form-group']} text-dark dark:text-white`}>
              <Select
                options={yearOptions}
                value={selectedYear}
                onChange={handleYearChange}
                placeholder="Yıl seçin..."
                className="dark:bg-gray-700 dark:text-white"
                classNamePrefix="dark-select"
              />
            </FilterCard.FormGroup>
          </FilterCard.Col>
          <FilterCard.Col className={styles['filter-col']}>
            <FilterCard.FormGroup label="Durum" className={`${styles['form-group']} text-dark dark:text-white`}>
              <Select
                options={statusOptions}
                value={selectedStatus}
                onChange={handleStatusChange}
                placeholder="Durum seçin..."
                className="dark:bg-gray-700 dark:text-white"
                classNamePrefix="dark-select"
              />
            </FilterCard.FormGroup>
          </FilterCard.Col>
        </FilterCard.Row>

        <FilterCard.Row className={styles['filter-row']}>
          <FilterCard.Col className={`${styles['filter-col']} ${styles['search-col']}`}>
            <FilterCard.SearchInput
              className={`${styles['search-input']} dark:bg-gray-700 dark:text-white dark:placeholder-gray-400`}
              placeholder="Ad, soyad veya bölüm ara..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </FilterCard.Col>
        </FilterCard.Row>
      </FilterCard>

      <div className="card border-0 shadow-sm bg-white dark:bg-gray-800">
        <div className="card-body card-wrapper">
          <Tabs activeTab={activeTab} onTabChange={setActiveTab} className="text-dark dark:text-white">
            <Tab id="birim-makale" title="Birim-Makale">
              {getFilteredAndSortedData(mockData['birim-makale']).length > 0 ? (
                <Table 
                  columns={columns['birim-makale']}
                  data={getFilteredAndSortedData(mockData['birim-makale'])}
                  onSort={handleSort}
                  sortConfig={sortConfig}
                  sortable
                />
              ) : (
                <NoDataFound />
              )}
            </Tab>
            <Tab id="birim-proje" title="Birim-Proje">
              {getFilteredAndSortedData(mockData['birim-proje']).length > 0 ? (
                <Table 
                  columns={columns['birim-proje']}
                  data={getFilteredAndSortedData(mockData['birim-proje'])}
                  onSort={handleSort}
                  sortConfig={sortConfig}
                  sortable
                />
              ) : (
                <NoDataFound />
              )}
            </Tab>
            <Tab id="akademisyen-makale" title="Akademisyen-Makale">
              {getFilteredAndSortedData(mockData['akademisyen-makale']).length > 0 ? (
                <Table 
                  columns={columns['akademisyen-makale']}
                  data={getFilteredAndSortedData(mockData['akademisyen-makale'])}
                  onSort={handleSort}
                  sortConfig={sortConfig}
                  sortable
                />
              ) : (
                <NoDataFound />
              )}
            </Tab>
            <Tab id="akademisyen-proje" title="Akademisyen-Proje">
              {getFilteredAndSortedData(mockData['akademisyen-proje']).length > 0 ? (
                <Table 
                  columns={columns['akademisyen-proje']}
                  data={getFilteredAndSortedData(mockData['akademisyen-proje'])}
                  onSort={handleSort}
                  sortConfig={sortConfig}
                  sortable
                />
              ) : (
                <NoDataFound />
              )}
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default Hedefler; 